import { render, staticRenderFns } from "./employerList.vue?vue&type=template&id=0b867670&scoped=true"
import script from "./employerList.vue?vue&type=script&lang=js"
export * from "./employerList.vue?vue&type=script&lang=js"
import style0 from "./employerList.vue?vue&type=style&index=0&id=0b867670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b867670",
  null
  
)

export default component.exports